module.exports = "//static.hsappstatic.net/LoginUI/static-1.13362/img/hubspotMobileApp2FA.png"